/**
 * RWS Tooltip Handler
 * Works with both static page content and dynamically loaded drawer content
 */
(function() {
  'use strict';

  // Use event delegation on document level
  document.addEventListener('click', function(e) {
    // Handle tooltip trigger clicks
    const trigger = e.target.closest('.product-details__rws-tooltip-trigger');
    
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      
      const tooltipId = trigger.getAttribute('data-tooltip-content');
      const tooltip = document.getElementById(tooltipId);
      
      if (tooltip) {
        // Close all other tooltips first
        document.querySelectorAll('.product-details__rws-tooltip.is-visible').forEach(function(t) {
          if (t !== tooltip) {
            t.classList.remove('is-visible');
          }
        });
        
        // Toggle this tooltip
        tooltip.classList.toggle('is-visible');
      }
      return;
    }
    
    // Close tooltips when clicking outside
    const clickedInsideTooltip = e.target.closest('.product-details__rws-tooltip');
    if (!clickedInsideTooltip) {
      document.querySelectorAll('.product-details__rws-tooltip.is-visible').forEach(function(tooltip) {
        tooltip.classList.remove('is-visible');
      });
    }
  });

  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.product-details__rws-tooltip.is-visible').forEach(function(tooltip) {
        tooltip.classList.remove('is-visible');
      });
    }
  });

  // Handle copy link buttons with visual feedback
  document.addEventListener('click', function(e) {
    const copyBtn = e.target.closest('.product-details__share-copy, [data-copy-link]');
    
    if (copyBtn) {
      e.preventDefault();
      const url = copyBtn.getAttribute('data-copy-link') || copyBtn.dataset.copyUrl;
      
      if (url) {
        navigator.clipboard.writeText(url).then(function() {
          const iconLink = copyBtn.querySelector('.icon-link');
          const iconCheck = copyBtn.querySelector('.icon-check');
          
          if (iconLink && iconCheck) {
            iconLink.style.display = 'none';
            iconCheck.style.display = 'block';
            
            setTimeout(function() {
              iconLink.style.display = 'block';
              iconCheck.style.display = 'none';
            }, 2000);
          }
        }).catch(function(err) {
          console.error('Failed to copy link:', err);
        });
      }
    }
  });
})();
